<template>
    <div v-if="visible" class="modal-overlay">
    <div class="modal">
      <h3 v-if="title">{{ title }}</h3>
      <p v-if="message">{{ message }}</p>
      <div class="botones">
        <button v-if="cancelText" class="btn cancelar" @click="$emit('cancel')">
          {{ cancelText }}
        </button>
        <button type="button" class="btn guardar" :disabled="confirmLoading" @click="$emit('confirm')">
          {{ confirmLoading ? 'Procesando...' : confirmText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
/**
 * Diálogo de confirmación para acciones destructivas.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

defineProps<{
  visible: boolean
  title?: string
  message?: string
  confirmText?: string
  cancelText?: string
  confirmLoading?: boolean
}>()

defineEmits<{
  (e: 'confirm'): void
  (e: 'cancel'): void
}>()
</script>

<style scoped>
.botones {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-md);
  margin-top: var(--space-lg);
}

.btn {
  padding: 8px 20px;
  height: 40px;
  font-weight: 600;
  font-size: var(--font-size-sm);
  font-family: var(--font-family);
  border: none;
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn.cancelar {
  background-color: white;
  border: 1px solid #ccc;
}

.btn.cancelar:hover {
  background-color: rgb(212, 26, 26);
  color: white;
}

.btn.guardar {
  background-color: #eea222;
  color: black;
}

.btn.guardar:hover {
  background-color: #0e69a0;
  color: white;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  animation: overlay-in 0.2s ease;
}

@keyframes overlay-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

.modal {
  background: white;
  padding: var(--space-lg);
  border-radius: var(--radius-lg);
  max-width: 400px;
  width: 90%;
  box-shadow: var(--shadow-lg);
  text-align: center;
  font-family: var(--font-family);
  animation: modal-in 0.2s ease;
}

@keyframes modal-in {
  from { opacity: 0; transform: scale(0.95) translateY(8px); }
  to { opacity: 1; transform: scale(1) translateY(0); }
}

.modal h3 {
  font-size: var(--font-size-lg);
  font-weight: 600;
  line-height: var(--line-height-tight);
  margin: 0 0 var(--space-sm) 0;
}

.modal p {
  font-size: var(--font-size-base);
  color: var(--text-secondary);
  line-height: var(--line-height-normal);
  margin: 0 0 var(--space-sm) 0;
}
</style>